import { Component, ContentChild, EventEmitter, Input, model, Output, signal, TemplateRef } from '@angular/core';

import { Menu, MenuItem } from '../detail-action-button/detail-action-buttons.types';
import { DetailHeader } from '../detail-header/detail-header.types';

import { MeetingItem } from '~/repositories/meeting/store/meeting.models';
import { ActivePreferences } from '~/repositories/userdata/store/userdata.models';

@Component({
  selector: 'app-detail-page',
  templateUrl: './detail-page.component.html',
  styleUrl: './detail-page.component.scss',
  standalone: false
})
export class DetailPageComponent {
  @Input() header: DetailHeader;
  @Input() headerLoading: boolean;
  @Input() sidebar: Menu[];
  @Input() sidebarKey: string;
  @Input() sidebarLoading: boolean;
  @Input() primaryActions: MenuItem[];
  @Input() primaryActionsLoading: boolean;
  @Input() checkedItems: MeetingItem[];
  @Input() userSettings: ActivePreferences = {};

  @Output() handleActionClick: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();
  @Output() handleEndAction: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();
  @Output() handleChangeUserSettings: EventEmitter<string> = new EventEmitter<string>();
  @Output() handleToggleSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();

  sidebarHovered = signal(false);

  @ContentChild('mainContent') mainContentTpl: TemplateRef<Element>;
  @ContentChild('extraOptionsContent') extraOptionsContentTpl: TemplateRef<Element>;

  protected readonly scrollContainerId = 'detail-page-scrollcontainer';

  handleHoverSidebar(hover: boolean) {
    this.sidebarHovered.set(hover);
  }

  handleUpdateSidebar(key: string) {
    this.handleChangeUserSettings.emit(key);
  }

  secondaryActionBarHidden = model<boolean>(false);

  isItemCollapsed = (id?: string) => {
    return this.userSettings[id] === true;
  };
}
